
import DaisoDialog from '~/components/common/modal/DaisoDialog.vue'
import CheckOrderAvailability from '~/components/common/holiday/CheckOrderAvailability.vue'
import SearchOrderAddress from '~/components/common/bulk/SearchOrderAddress.vue'
import AddOrderAddress from '~/components/common/bulk/AddOrderAddress.vue'
import { commonfunc } from '~/mixin/common.js'

export default {
  name: 'StepDialogHoliday',
  components: {
    DaisoDialog,
    CheckOrderAvailability,
    SearchOrderAddress,
    AddOrderAddress
  },
  mixins: [commonfunc],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    purchaseValue: { // 01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량배송
      type: String,
      default: '01'
    },
  },
  data () {
    return {
      // 컴포넌트 depth 정보
      step: 0,
      activeComponentData: [
        {
          title: '휴일도착 가능 지역 확인',
          component: 'SearchOrderAddress'
        },
        {
          title: '휴일도착 가능 지역 확인',
          component: 'CheckOrderAvailability'
        },
        {
          title: '배송지 등록',
          component: 'AddOrderAddress'
        },
      ],
      usePossible: false, // 배송 가능 여부
      addrInfo: {}, // 주소정보
      reOpen: false,
    }
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible) {
        this.init()
        this.reOpen = true
      }
    }
  },
  mounted () {
    this.usePossible = false
    this.reOpen = false
  },
  methods: {
    closePopup (type) {
      this.reOpen = false
      this.$emit('closePopup', type)
    },
    init () {
      this.step = 0
      this.usePossible = false
      this.addrInfo = {}
    },
    async nextStep (step, item) {
      if (this.isEmpty(step)) {
        return 'error'
      }
      if (step === 0) {
        this.init()
      } else if (step === 1) {
        this.addrInfo = item
        this.step = step
        await this.selHldyDlvRgar(item.addrZip)
      } else if (step === 2) {
        this.step = step
      } else if (step === 3) {
        this.closePopup()
      }
    },
    selHldyDlvRgar (zipCd) {
      return new Promise((resolve, reject) => {
        const params = { zip: zipCd }
        this.$AxiosBuilder
          .params(params)
          .build()
          .get('/common/dla-api/selHldyDlvRgar')
          .then((res) => {
            const result = res.data
            result > 0 ? this.usePossible = true : this.usePossible = false
            resolve()
          }).catch((err) => {
            console.log(err)
            resolve()
          })
      })
    },
  }
}
